import { useCallback, useState } from 'react';
import { generateTCStringFromModel, modifyTCStringCookie } from './tcf-api';

/**
 * This hook is really just to force react to re-render since
 * IAB-TCF is managing vendor and purpose checkbox state outside of React state.
 *
 * It will also set the TCString cookie when refreshed.
 */
export default function useTCString() {
  const [tcString, setTCString] = useState(null);

  const refreshTCString = useCallback(() => {
    setTCString(generateTCStringFromModel());
    modifyTCStringCookie();
  }, []);

  return { tcString, refreshTCString };
}
